import { combineReducers } from 'redux';
import { SELECTED_RESELLER_CHANGED } from '../actions/resellerActions';
import attachmentsReducer from './attachmentsReducer';
import { carriersReducer } from './carriersReducer';
import { detailedClaimReducer } from './detailedClaimReducer';
import { extractionListReducer } from './extractionListReducer';
import { managedUserReducer } from './managedUserReducer';
import { poReviewDraftReducer } from './poReviewDraftReducer';
import { promotionReducer } from './promotionReducer';
import { resellerClaimListReducer } from './resellerClaimListReducer';
import { resellerReducer } from './resellerReducer';
import { resellerReturnOrderListReducer } from './resellerReturnOrderListReducer';
import { returnOrderAuditHistoryReducer } from './returnOrderAuditHistoryReducer';
import { returnOrderDraftReducer } from './returnOrderDraftReducer';
import { returnOrderProblemShelfReducer } from './returnOrderProblemShelfReducer';
import { returnOrderReducer } from './returnOrderReducer';
import { returnOrderTrackingReducer } from './returnOrderTrackingReducer';
import { salesOrderDemandReducer } from './salesOrderDemandReducer';
import { systemReducer } from './systemReducer';
import { termsAndConditionsReducer } from './termsAndConditionsReducer';
import { userReducer } from './userReducer';

const appReducer = combineReducers({
    systemReducer,
    resellerReducer,
    userReducer,
    managedUserReducer,
    returnOrderAuditHistoryReducer,
    returnOrderTrackingReducer,
    returnOrderDraftReducer,
    returnOrderProblemShelfReducer,
    returnOrderReducer,
    resellerReturnOrderListReducer,
    resellerClaimListReducer,
    termsAndConditionsReducer,
    attachmentsReducer,
    carriersReducer,
    detailedClaimReducer,
    promotionReducer,
    salesOrderDemandReducer,
    extractionListReducer,
    poReviewDraftReducer,
});

export const rootReducer: typeof appReducer = (state, action) => {
    if (action.type === SELECTED_RESELLER_CHANGED && state) {
        // Preserve only system, reseller, and user state; reset everything else
        return appReducer(
            {
                ...({} as ReturnType<typeof appReducer>),
                systemReducer: state.systemReducer,
                resellerReducer: state.resellerReducer,
                userReducer: state.userReducer,
            },
            action
        );
    }
    return appReducer(state, action);
};
